import moment from "moment";
import "moment/locale/ur";
import { toArabicNumerals } from "./numerals";

moment.locale("ur");

export function mysqlDateToArabic(date: Date) {
    if (!date) {
        return "";
    }

    return toArabicNumerals(moment(date).utc().format("D MMM YYYY"));
}

export function publishedDate(date: Date) {
    if (!date) {
        return "";
    }

    return toArabicNumerals(moment(date).utc().format("MMM YYYY"));
}
